module.exports = __webpack_public_path__ + "img/document.f3e3082b.svg";